import { t } from "i18next";
import SwitchAuthentication from "./components/SwitchAuthentication";

export const SecuritySettings = (): JSX.Element => {
  return (
    <section>
      <div className="space-y-8">
        <p>{t("settings.security.label2FMA")}</p>
        <SwitchAuthentication />
      </div>
    </section>
  );
};
